var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.2 1l-1.5 3.7c7.2 2.1 12.6 8.6 13.2 16.3l3.9-1.4c-1.1-8.7-7.3-16-15.6-18.6z"
  })));
}
export default SvgLoadingButton;